<template>
  <!-- eslint-disable -->
  <div>
    <entrada-add :is-add.sync="isAdd" ref="entradaAdd"> </entrada-add>
    <b-card no-body>
      <b-card-header class="">
        <h5>
          Filtros
          <template v-if="!see_more">
            <a class="control-label font-weight-bold text-info font-custom" @click="clickSeeMore"
              ><strong> [+ Ver más]</strong></a
            >
          </template>
          <template v-else>
            <a class="control-label font-weight-bold text-info font-custom" @click="clickSeeMore"
              ><strong> [- Ver menos]</strong></a
            >
          </template>
        </h5>
        <div class="d-flex align-items-center justify-content-end">
          <!-- @click="isAddNewUserSidebarActive = true"< -->
          <b-button variant="primary" class="mb-25" @click="addLocal">
            <span class="text-nowrap">Agregar elemento</span>
          </b-button>
        </div>
      </b-card-header>
      <b-card-body v-if="see_more">
        <b-row>
          <b-col md="3" class="mb-md-0 mb-2">
            <!-- @input="(val) => $emit('update:roleFilter', val)" -->
            <label>Nombre</label>
            <b-form-input v-model="codigo" placeholder="Nombre" />
          </b-col>
          <b-col md="6" class="mt-2">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-1" @click.prevent="filter">
              <feather-icon icon="SearchIcon" class="mr-50" />
              <span class="align-middle">Buscar</span>
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="secondary"
              class="mr-1"
              @click.prevent="clean"
            >
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span class="align-middle">Limpiar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable*/
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton,BFormGroup, BFormInput } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import entradaAdd from './entradaAdd.vue'
export default {
  directives: {
    Ripple
  },
  data() {
    return {
      isAdd: false,
      isUpdate: false,
      see_more: false,
      codigo: '',
      company_id: null,
      roleFilter: null,
      records: [],
      showEntrie: 10,
      arrayFilters: [],
      userData:{},
    }
  },
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    entradaAdd
  },
  mounted() {
    // this.getCompanys()
    // this.getData()
  },
  methods: {
    // getData(){
    //   this.userData = JSON.parse(localStorage.getItem('userData'))
    // },
    clickSeeMore() {
      this.see_more = !this.see_more
    },
    addLocal(){
      this.isAdd = true
      this.$refs.entradaAdd.getData({})
    },
    // async getCompanys() {
    //   const url = `?per_page=${this.showEntrie}&filters=${JSON.stringify(this.arrayFilters)}`
    //   const resp = await CompanyService.getCompanys(url, this.$store)
    //   console.log('respCompany', resp)
    //   if (resp) {
    //     this.records = resp.data.data
    //   }
    // },
    async filter() {
      //armar la estructura del api
      // var arrayFilter = []
      // if (this.codigo != '') {
      //   arrayFilter.push({
      //     field: 'codigo',
      //     operator: 'like',
      //     value: this.codigo
      //   })
      // }
      // if (this.company_id != null) {
      //   arrayFilter.push({
      //     field: 'company_id',
      //     operator: 'like',
      //     value: this.company_id
      //   })
      // }
      // console.log('arrayFilter', arrayFilter)
      // console.log('this.company_id', this.company_id)
      // this.$parent.$parent.arrayFilters = arrayFilter
      // await new Promise((resolve) => setTimeout(resolve, 100))
      // this.$parent.$parent.getData()
    },
    clean() {
      // this.title = ''
      // this.company_id = null
      // var arrayFilter = []
      // this.$parent.$parent.arrayFilters = arrayFilter
      // this.$parent.$parent.getData()
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
